import { RpcService } from 'rpc';

export interface RosterMember {
	membercode: number;
	member_id: string;
	firstname: string;
	lastname: string;
	fullname: string;
	email: string;
	is_instructor: boolean;
	bio?: string;
	avatar: string;
	has_avatar: boolean;
}

export declare interface IRosterService extends RpcService {
	roster_members(param: { session_id?: number; select?: Record<string, unknown> }): Promise<RosterMember[]>;
}

export const svc: IRosterService = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/@@sessions.rpc`,

	services: {
		roster_members: {
			parameters: [
				{ name: 'session_id', type: 'integer', optional: false },
				{ name: 'select', type: 'object', optional: true }
			]
		}
	}
}) as IRosterService;

export default svc;
